import Vue from 'vue'
import Router from 'vue-router'
import HomePage from '@/components/HomePage'
import LoginPage from '@/components/LoginPage'
import ProductDetail from '@/components/ProductDetailPage'
import RegisterPage from '@/components/RegisterPage'
import ForgotPage from '@/components/ForgotPage'
import CategoryPage from '@/components/CategoryPage'
import MyOrdersPage from '@/components/MyOrdersPage'
import store from '@/store';
import CartPage from '@/components/CarritoPage';
import SearchResultsPage from '@/components/SearchResultsPage';

Vue.use(Router)


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage,
      meta: {auth: true}
    },
    {
      path: '/product/:id',
      name: 'ProductDetail',
      component: ProductDetail,
      meta: {auth: true}
    },
    {
      path: '/cart',
      name: 'CartDetail',
      component: CartPage,
      meta: {auth: true}
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginPage,
      meta: {auth: false,visibleIfLogged:false}
    },
    {
      path: '/register',
      name: 'Register',
      component: RegisterPage,
      meta: {auth: false,visibleIfLogged:false}
    },
    {
      path: '/forgot',
      name: 'Forgot',
      component: ForgotPage,
        meta: {auth: false,visibleIfLogged:false}
    },
    {
      path: '/category/:id',
      name: 'Category',
      component: CategoryPage,
      meta: {auth: true}
    },
    {
      path: '/search/:keyword',
      name: 'Search',
      component: SearchResultsPage,
      meta: {auth: true}
    },
    {
      path: '/myorders',
      name: 'MyOrders',
      component: MyOrdersPage,
      meta: {auth: true}
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (!store.getters.isLogged) {
      next({path: '/login',});
    } else {
      next();
    }
  } else {
    if (!to.meta.visibleIfLogged){
      if (store.getters.isLogged) {
        next({path: '/',});
      }else{
        next();
      }
    }else{
      next();
    }

  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js